"use strict";
// @ts-ignore
try {
    self['workbox:expiration:5.1.3'] && _();
}
catch (e) { }
